export const CANT_PLAY_AGAIN = 'cant_play_again';

/**
 * True when a rejected spot request means the server has the spot as already played: an
 * axios error whose response lists `cant_play_again` under `errors`, or the bare error code
 * (server answered 200 with it as `message`). Network errors and timeouts have no response
 * and yield false.
 */
export function isCantPlayAgainError(error) {
    if (error === CANT_PLAY_AGAIN) {
        return true;
    }
    const errors = error && error.response && error.response.data ? error.response.data.errors : null;
    if (!errors) {
        return false;
    }
    const values = typeof errors === 'string' ? [errors] : Object.values(errors);
    return values.includes(CANT_PLAY_AGAIN);
}
